import React, { useContext, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import "./restaurentPage.css"
import FoodItemList from '../../components/food-item/FoodItemList'
import RestaurentInfoComponent from './components/rest-info-comp/RestaurentInfoComponent'
import RestaurentContext from '../../context/rest_context'
import { db } from "../../config/firebase_config.js";
import { ref, get, onValue } from 'firebase/database';
import RestItemCategoriesModel from "../../models/Restaurent_category.js";
import RestaurentFoodModel from "../../models/Restaurent_food_model.js";
import ShowMenu from "./components/menu-comp/ShowMenu.jsx";
import SearchItemsContainer from './components/search-items/SearchItemsContainer'
import FoodTypeFilter from './components/food-type-filters/FoodTypeFilter';
import RestaurentModel from '../../models/Restaurent_model';
import RestBottomSheet from './components/bottomsheet/RestBottomSheet';
import CartContext from '../../context/cart_context';
import RestaurentAlert from './components/alert-comp/RestaurentAlert'
import { ItemSkeleton } from "../../components/skeletons/skeletons.jsx";
import { isRestCategoryAvailable } from "../../functions/mini_func.js"
import { GoAlert } from "react-icons/go";

const RestaurentPage = () => {

  const { setRestCat, setRestItems, restCat, setFilterRestItems, restItems } = useContext(RestaurentContext);
  const { setSelectedfoodItemList, setCartItems, setSelectedRest, showAlert } = useContext(CartContext);


  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tappedStore = queryParams.get('storeID') || queryParams.get('restID');


  const initalizeData = () => {

    // console.log("initalsing function of init");
    const savedRestData = localStorage.getItem('selected-rest');
    const savedCartItemsData = localStorage.getItem('cart-items');
    const savedCartListData = localStorage.getItem('cart-list');

    if (savedCartListData != null && savedCartItemsData != null && savedCartListData != null) {
      // console.log("enter the dragon")
      // console.log("savedRestData" , savedRestData , "savedCartItemsData" , savedCartItemsData , "savedCartListData" , savedCartListData  )
      const savedRest = JSON.parse(savedRestData);
      console.log({ savedRest });
      setSelectedRest(RestaurentModel.fromJson(savedRest.dbID, savedRest));
      setCartItems(JSON.parse(savedCartItemsData));
      const itemsListData = JSON.parse(savedCartListData);
      const itemsList = itemsListData.map((data) => RestaurentFoodModel.fromJson(data.dbID, data));
      // console.log(itemsList);
      setSelectedfoodItemList(itemsList);
      setFilterRestItems(restItems);
    }

  }

  useEffect(() => {

    const fetchData = async () => {

      try {

        const databaseRef = ref(db, `${tappedStore}_Category`);
        const snapshot = await get(databaseRef);
        let restItemModel = [];
        if (snapshot.exists()) {
          const data = snapshot.val();
          console.log("category values", data);
          Object.entries(data).forEach(([key, value]) => {
            const restCatModel = RestItemCategoriesModel.fromJson(key, value)
            if (isRestCategoryAvailable(restCatModel) && restCatModel.visibility == "Yes") {
              restItemModel.push(restCatModel);
            }
          })
          console.log("active cat values", restItemModel);

          let foodItems = [];
          for (const cat of restItemModel) {
            const dbFoodModelRef = ref(db, `${cat.restaurantMenuId}_${cat.name}`);
            const foodSnap = await get(dbFoodModelRef);
            if (foodSnap.exists()) {
              const data = foodSnap.val();
              console.log("food items : ", data);
              Object.entries(data).forEach(([key, value]) => {
                const restItem = RestaurentFoodModel.fromJson(key, value);
                if (isRestCategoryAvailable(restItem) && restItem.visibility == "Yes") {
                  foodItems.push(restItem);

                }
              });
            }
          }
          console.log("active food items : ", foodItems);
          setRestItems(foodItems);
          setFilterRestItems(foodItems);
          setRestCat(restItemModel);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const restCatListeners = () => {
      console.log("<----- initiation started ----->");
      console.log(`<----- initiation started ${tappedStore} ----->`);

      try {
        const databaseRef = ref(db, `${tappedStore}_Category`);
        onValue(databaseRef, (snapshot) => {
          let restItemModel = [];
          console.log(`<-------------- onValue is executing ra ayya   --------------->`);
          if (snapshot.exists()) {
            console.log(`<-------------- snapshot is not null in onvalue   --------------->`);
            const data = snapshot.val();
            Object.entries(data).forEach(([key, value]) => {
              const restCatModel = RestItemCategoriesModel.fromJson(key, value);
              if (isRestCategoryAvailable(restCatModel) && restCatModel.visibility == "Yes") {
                // console.log(restCatModel);
                restItemModel.push(restCatModel);
              }
            });
            console.log("<----- on value cat data ------>", restItemModel, "<----- on value cat data ------>");
            setRestCat(restItemModel);
            restItemsListeners(restItemModel);
          }
        });

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const updateData = async (restCateg, updatedFood) => {
      let foodItems = [];
      for (const cat of restCateg) {
        const dbFoodModelRef = ref(db, `${cat.restaurantMenuId}_${cat.name}`);
        const foodSnap = await get(dbFoodModelRef);
        if (foodSnap.exists()) {
          const data = foodSnap.val();
          Object.entries(data).forEach(([key, value]) => {
            const restItem = RestaurentFoodModel.fromJson(key, value);
            if (isRestCategoryAvailable(restItem) && restItem.visibility == "Yes") {
              foodItems.push(restItem);
            }
          });
        }
      }
      if (updatedFood.length > 0) {
        console.log(`>>>>> running from updatedData ${foodItems.length}  --- ${updatedFood.length}`);
        let newFoodItems = foodItems.filter(item => item.categoryName !== updatedFood[0].categoryName);
        newFoodItems.push(...foodItems);
        setRestItems(newFoodItems);
        setFilterRestItems(newFoodItems);

      }


    }

    const restItemsListeners = async (restCateg) => {
      console.log("<----- initiation started ----->");
      console.log(`<----- initiation started ${tappedStore} ----->`);

      try {
        for (const cat of restCateg) {

          const dbFoodModelRef = ref(db, `${cat.restaurantMenuId}_${cat.name}`);
          onValue(dbFoodModelRef, (foodSnap) => {
            console.log(`restItems listeners are invovked for  ${foodSnap.val()}`);
            if (foodSnap.exists()) {
              let foodItems = [];
              const data = foodSnap.val();
              Object.entries(data).forEach(([key, value]) => {
                const restItem = RestaurentFoodModel.fromJson(key, value);
                if (isRestCategoryAvailable(restItem) && restItem.visibility == "Yes") {
                  foodItems.push(restItem);
                }
              });
              console.log(`<---- food Items lenth is ${foodItems.length}  and resst items is ${restItems.length} ---->`);
              if (restItems.length > 0 && foodItems.length > 0) {
                console.log("<--------------  why this is happening yaar   ---------------->");
                console.log(restItems[0].categoryName);
                console.log("<--------------  why this is happening yaar   ---------------->");
                let newFoodItems = restItems.filter(item => item.categoryName !== foodItems[0].categoryName);
                newFoodItems.push(...foodItems);
                setRestItems(newFoodItems);
                setFilterRestItems(newFoodItems);
              } else {
                updateData(restCateg, foodItems);
              }
            }
          });
        }
        //  console.log("<----- item data ------>", foodItems, "<----- item data ------>");

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };


    initalizeData();
    // if(restCat.length == 0){
    fetchData();
    // }
    restCatListeners();
    return () => {
      setRestCat([]);
      setRestItems([]);
    }

  }, [tappedStore])

  console.log("<---- restCat ---->", restCat, "<---- restCat ---->");

  return (
    <div className='rest-page-container'>
      <RestaurentInfoComponent restID={tappedStore} />
      <SearchItemsContainer />
      <FoodTypeFilter />
      {
        restCat.length == 0
          ? (<>
            <ItemSkeleton />
            <ItemSkeleton />
            <ItemSkeleton />
            <ItemSkeleton />
            <ItemSkeleton />
            <ItemSkeleton />
          </>
          )
          : (
            restCat.map((value, index) => {
              console.log(`<--------------  ${value}  --------------->`);
              return <FoodItemList key={index} foodCat={value} />
            })
          )

      }
      <div className="add-extra-space"></div>
      <div className='menu-container'><ShowMenu /> </div>
      <RestBottomSheet />
      {
        showAlert &&
        <RestaurentAlert />
      }
    </div>
  )
}

export default RestaurentPage